import React from 'react'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'

import IssueCommentsContainer from '../../containers/issues/issue-comments-container'
import IssueHistoriesListContainer from '../../containers/issue-histories/issue-histories-list-container'

export default ({
  issue,
  onTabSelect,
  selectedTab
}) => (
  <Tabs onSelect={onTabSelect} selectedIndex={selectedTab}>
    <TabList>
      <Tab>Comments</Tab>
      <Tab>History</Tab>
    </TabList>

    <TabPanel>
      <IssueCommentsContainer issue={issue} />
    </TabPanel>

    <TabPanel>
      <IssueHistoriesListContainer issue={issue} />
    </TabPanel>
  </Tabs>
)



// WEBPACK FOOTER //
// ./src/components/issues/issue-tabs.js